import { render, staticRenderFns } from "./FullMetarialEager.vue?vue&type=template&id=0d21d393&"
import script from "./FullMetarialEager.vue?vue&type=script&lang=js&"
export * from "./FullMetarialEager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports